import type { ChangeEvent } from 'react';
import { useController, useFormContext } from 'react-hook-form';

import { QuantityPicker } from '@libs/shared-ui';

import type { FormFields } from '@/entities/purchase-form';

import { useQuantity } from '../../model';

export const QuantitySelector = () => {
    const { control, watch } = useFormContext<FormFields>();
    const { items, disabled, fulfilmentMethod, sku, shouldRender } = useQuantity();
    const purchaseOption = watch('purchaseOption');
    const { field } = useController({ name: 'quantity', control });

    if (!shouldRender) return null;

    return (
        <QuantityPicker
            items={items}
            disabled={disabled}
            value={String(field.value)}
            key={`${sku}-${fulfilmentMethod}-${purchaseOption}`}
            name={field.name}
            onChange={(event: ChangeEvent<HTMLSelectElement>) => field.onChange(Number(event.target.value))}
            onBlur={field.onBlur}
        />
    );
};
